<script>
    import localGeos from "../stores/localGeos";
    import GeoItem from "./GeoItem.svelte";
    import {
        scrollToElement,
        findNode,
        searchNodes,
        backPath,
        upCaseStr,
        getParentNodes,
        expandParents,
        findNodeParentOfLevel,
        collapseAll,
        setFocusTo,
        JSONClone
    } from "../lib/lib";
    import {localGeosLoad} from "../lib/requests";
    import app_alert from "../stores/alerts";
    import success from '../stores/success';
    import error from '../stores/error';

    let geoSearchTerm = '';
    let oldSearchTerm = '';
    let searchResults = [];
    let searchIndex = null;
    let onRegionSearch = true;
    let oldSelectedId = null;
    let selectedGeoParentPath = "";
    let matchSource = 0;

    let editedGeo = null;

    const resetNode = (node) => {
        node.map(item => {
            item.geo_matches = null;
            if (item.children.length) {
                Initialize(item.children);
            }
        });
    }

    const Initialize = (list = null) => {
        // Initialize all tree items
        let resetTree = false;
        if (!list) {
            list = $localGeos.tree;
            resetTree = true;
        }
        list.map(item => {
            item.geo_matches = null;
            if (item.children.length) {
                Initialize(item.children);
            }
        });
        if (resetTree) {
            $localGeos.tree = $localGeos.tree;
        }
    }

    const onSearch = (event) => {
        if (event.key === 'Enter') {
            if (oldSearchTerm !== geoSearchTerm) {
                resetSearch();
                if (geoSearchTerm.length > 0) {

                    if (!isNaN(geoSearchTerm)) {
                        // if search term is a location id
                        searchResults = [];
                        let node = findNode(geoSearchTerm, $localGeos.tree);
                        if (node) {
                            searchResults.push(node.id);
                        }
                    } else {
                        // if search term is a string
                        let tree = $localGeos.tree;
                        if (onRegionSearch && $localGeos.selected_id > 0) {
                            // get node parent region
                            let region = findNodeParentOfLevel($localGeos.selected_id, 0, tree);
                            if (region) {
                                tree = region.children;
                            }
                        }

                        // put "Άνω" and "Κάτω" first
                        geoSearchTerm = geoSearchTerm.trim();
                        let arr = geoSearchTerm.split(" ");
                        if (arr.length) {
                            let lastWord = arr[arr.length - 1];
                            if (lastWord === "Επάνω" || lastWord === "Άνω" || lastWord === "Κάτω") {
                                arr.unshift(lastWord);
                                arr.pop();
                                geoSearchTerm = arr.join(' ');
                            }
                        }

                        searchResults = searchNodes(upCaseStr(geoSearchTerm), tree);
                    }

                    oldSearchTerm = geoSearchTerm;
                    if (searchResults.length === 0) {
                        error.show("Δεν βρέθηκαν αποτελέσματα");
                    } else {
                        $localGeos.last_selected_id = $localGeos.selected_id;
                    }
                }
            }
            showNextSearchResult();
        } else if (event.key === 'Escape') {
            geoSearchTerm = '';
            resetSearch();
        }
    }

    const resetSearch = () => {
        oldSearchTerm = '';
        searchResults = [];
        searchIndex = null;
        $localGeos.marked_id = 0;
    }

    const showNextSearchResult = () => {
        if (searchResults.length > 0) {
            if (searchIndex === null) {
                searchIndex = 0;
            } else {
                searchIndex++;
                if (searchIndex > searchResults.length - 1) {
                    searchIndex = 0;
                }
            }

            $localGeos.marked_id = searchResults[searchIndex];
            gotoLocation(searchResults[searchIndex], false);
        }
    }

    const gotoLocation = (id, collapse_expanded = true) => {
        let node = findNode(id, $localGeos.tree);
        if (!node) {
            return;
        }
        let parents = getParentNodes(node, $localGeos.tree);
        parents.map(item => {
            item.expanded = true;
        });
        $localGeos.selected_id = id;
        if (collapse_expanded) {
            onCollapseAll();
        }
        $localGeos.tree = $localGeos.tree;
        scrollToElement('geo-item-' + id);
    }

    const toggleSearchScope = () => {
        onRegionSearch = !onRegionSearch;
        resetSearch();
    }

    const anOtherIsEdited = () => {
        if ($localGeos.edit_id !== null) {
            app_alert.show('error', "Έχετε ήδη ανοιχτή μια τοποθεσία για επεξεργασία");
            return true;
        }
        return false;
    }

    const noneSelected = () => {
        if ($localGeos.selected_id === 0) {
            app_alert.show('error', "Δεν έχετε επιλέξει περιοχή!");
            return true;
        }
        return false;
    }

    const getSelected = () => {
        let geo = findNode($localGeos.selected_id, $localGeos.tree);
        if (!geo) {
            app_alert.show('error', `Δεν βρέθηκε περιοχή με id ${$localGeos.selected_id}!`);
        }
        return geo;
    }


    const onEdit = (data) => {
        if (anOtherIsEdited()) {
            return;
        }
        if (noneSelected()) {
            return;
        }

        if (!data) {
            editedGeo = JSONClone(findNode($localGeos.selected_id, $localGeos.tree));
            return;
        }

        editedGeo = JSONClone(data.detail);
    }

    const closeEdit = data => {
        editedGeo = null;

        if (data) {
            let parent = null;

            let node = findNode(data.id, $localGeos.tree);
            if (!node) {
                // new geo
                parent = findNode(data.parent_id, $localGeos.tree);
                parent.children = [...parent.children, data];
            } else {
                if (data.parent_id !== node.parent_id) {
                    // remove geo from parent
                    parent = findNode(node.parent_id, $localGeos.tree);
                    parent.children = parent.children.filter(x => x.id !== data.id);
                    // add geo on new parent
                    parent = findNode(data.parent_id, $localGeos.tree);
                    parent.children = [...parent.children, data];
                }
                node.parent_id = data.parent_id;
                node.name_el = data.name_el;
                node.name_en = data.name_en;
                node.slug = data.slug;
                node.level = data.level;
                node.latlng = data.latlng;
                node.old_id = data.old_id;
                node.is_deprecated = data.is_deprecated;
            }
            $localGeos.tree = $localGeos.tree;
            expandParents($localGeos.selected_id, $localGeos.tree);
        }
    }


    const load = async () => {
        const [err, res] = await localGeosLoad();

        if (err) {
            alert('error ' + err)
            return;
        }

        $localGeos.tree = res.tree;

        if ($localGeos.selected_id === 0 && res.last_selected_id > 0) {
            $localGeos.selected_id = res.last_selected_id;
        }

        if ($localGeos.selected_id > 0) {
            expandParents($localGeos.selected_id, $localGeos.tree);
        }
    }

    const onCollapseAll = () => {
        collapseAll($localGeos.tree, $localGeos.selected_id);
        $localGeos.tree = $localGeos.tree;
        scrollToElement('geo-item-' + $localGeos.selected_id);
    }

    const onGotoLastSelected = () => {
        $localGeos.selected_id = $localGeos.last_selected_id;
        scrollToElement('geo-item-' + $localGeos.selected_id);
    }

    load();

    $: {
        if (matchSource !== !$localGeos.match_source) {
            matchSource = $localGeos.match_source;
            Initialize();
        }
        if (oldSelectedId === null && $localGeos.selected_id > 0) {
            oldSelectedId = 0;
            expandParents($localGeos.selected_id, $localGeos.tree);
        }
        if (oldSelectedId !== $localGeos.selected_id) {
            oldSelectedId = $localGeos.selected_id;
            selectedGeoParentPath = backPath($localGeos.selected_id, $localGeos.tree);
        }
        if ($localGeos.search_term) {
            geoSearchTerm = $localGeos.search_term;
            $localGeos.search_term = '';
            onSearch({key: 'Enter'});
        }
        if (!geoSearchTerm && oldSearchTerm) {
            resetSearch();
        }
    }
</script>

<div class="section-header">
    <div class="row">
        <div class="col-md-8">
            <button class="btn btn-primary" title="Επεξεργασία επιλεγμένης" on:click="{() => onEdit() }"><i
                    class="fa fa-edit"></i></button>
            <span class="separator"></span>
            <button class="btn btn-primary" on:click="{ onCollapseAll }" title="Κατάρρευση όλων"><i
                    class="fa fa-toggle-up"></i></button>
            <span class="separator"></span>
            <button class="btn btn-primary" on:click="{ load }" title="Ανανέωση περιοχών"><i class="fa fa-refresh"></i>
            </button>
        </div>
        <div class="col-md-4">
            <div class="form-inline text-right">
                <button class="btn btn-primary" title="αναζήτηση στον νομό" on:click="{ toggleSearchScope }">
                    {#if onRegionSearch}
                        <i class="fa fa-map"></i>
                    {:else}
                        <i class="fa fa-map-o"></i>
                    {/if}
                </button>
                <input type="text" class="form-control" bind:value="{ geoSearchTerm }" on:keyup="{ onSearch }"
                       placeholder="αναζήτηση">
                <button class="btn btn-primary" title="επιστροφή στην αρχική επιλογή" on:click="{ onGotoLastSelected }">
                    <i class="fa fa-arrow-left"></i></button>
            </div>
        </div>
    </div>
</div>

<div class="panel">
    <div class="panel-heading">
        <h2>Περιοχές - Κρητικές Αγγελίες</h2>
        <h6>{ selectedGeoParentPath }</h6>
    </div>
    <div class="panel-body fixed-height">
        <div class="panel-body-inner">
            {#each $localGeos.tree as geo}
                <GeoItem geo="{ geo }" on:edit="{ onEdit }"/>
            {/each}
        </div>
    </div>
</div>

<!--{#if editedGeo != null}-->
<!--    <GeoModal modalMd geo={editedGeo} closeCallback={closeEdit}/>-->
<!--{/if}-->
